module.exports = __webpack_public_path__ + "img/h.7a00c47d.jpg";